import styles from './Orders.module.css';
import {useState, useContext, useEffect} from 'react';
import { UserContext } from '../../UserContext.js';
import useSites from '../../hooks/useSites.js';
import helpers from '../../helpers.js';

import Button from "../../components/Button.js";
import Overlay from "../../components/Overlay.js";
import Selector from "../../components/Selector.js";
import OrderForm from "../../components/OrderForm.js";

function Orders(props) {
  const {user} = useContext(UserContext);
  const [displayScheduleOverlay, setDisplayScheduleOverlay] = useState(false);
  const [orderToUpdate, setOrderToUpdate] = useState(null);
  const [deliveries, setDeliveries] = useState(null);
  const [assignedDeliveryID, setAssignedDeliveryID] = useState("newDelivery");
  const [deliverToSite, setDeliverToSite] = useState(false);
  const canDeliverToSite = Boolean(props?.farmer?._storage_site);
  const [pincharEbcRequired, setPincharEbcRequired] = useState(true);
  const [pelletcharEbcRequired, setPelletcharEbcRequired] = useState(false);
  const [originSiteId, setOriginSiteId] = useState("");
  const { sites, loading: sitesLoading, error: sitesError } = useSites(user, displayScheduleOverlay);

  const [formData, setFormData] = useState({
    pincharBags: 0,
    pelletcharBags: 0,
    deliveryId: "",
    date: helpers.toDateInputValue(new Date())
  });

  const fetchUpcomingDeliveries = async () => {
    const request = {
      method: "get",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + user.token,
      }
    };

    let response = await fetch(user.backEndURL + "/deliveries", request);
    let jsonResponse = await response.json();
    if (jsonResponse.success) {
      setDeliveries(jsonResponse.data);
    }
  }

  useEffect(() => {
    fetchUpcomingDeliveries();
  },[user])

  useEffect(() => {
    setDeliverToSite(false);
    setOriginSiteId("");
  }, [props?.farmer?._id]);

  const handleChange = (formField, value) => {
    setFormData({ ...formData, [formField]: value });

  };
  
  const scheduleOrder = async () => {
    if (!formData.date) {
      alert("Please choose a delivery date.");
      return;
    }
    const request = {
      method: "post",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + user.token,
      },
      body: JSON.stringify({
        products: [
          {_product: "651d47889b872e666d637d8f", amount: formData.pincharBags, ebc_required: pincharEbcRequired},
          {_product: "688a173e446673349432efc4", amount: formData.pelletcharBags, ebc_required: pelletcharEbcRequired}
        ],
        userId: props.farmer._id,
        deliveryId: assignedDeliveryID,
        deliveryDate: formData.date,
        destinationType: deliverToSite ? "storage" : "farm",
        ...(deliverToSite && props.farmer._storage_site ? { siteId: props.farmer._storage_site } : {}),
        ...(originSiteId ? { originSiteId } : {}),
      })
    };
    
    let response = await fetch(user.backEndURL + "/order", request);
    let jsonResponse = await response.json();
    if (jsonResponse.success) {
      alert("Successfully Scheduled!");
      setDisplayScheduleOverlay(false);
      props.updateFarmerList();
    } else {
      alert("Something went wrong...")
    }
  }

  const renderScheduleOrder = () => {
    if(displayScheduleOverlay){
      let deliveriesData = [{name: "New Delivery", value: "newDelivery"}];
      if(deliveries !== null && deliveries.length !== 0){
        deliveries.forEach((delivery) => {
          let totalBags = 0;
          if(delivery.orders && delivery.orders.length > 0){
            delivery.orders.forEach((order) => {
              if(order.products && order.products.length > 0){
                order.products.forEach((product) => {
                  totalBags += product.amount || 0;
                });
              }
            });
          }
          let deliveryData = {
            name: delivery.delivery_id + (totalBags > 0 ? " (" + totalBags + " bags)" : ""),
            value: delivery._id
          }
          deliveriesData.push(deliveryData);
        })
      }
      return(
        <OrderForm
          formData={formData}
          onChange={handleChange}
          products={[
            { name: 'PinChar', fieldName: 'pincharBags', ebcRequired: pincharEbcRequired,
              onEbcChange: () => setPincharEbcRequired(!pincharEbcRequired) },
            { name: 'PelletChar', fieldName: 'pelletcharBags', ebcRequired: pelletcharEbcRequired,
              onEbcChange: () => setPelletcharEbcRequired(!pelletcharEbcRequired) },
          ]}
          deliveries={deliveriesData}
          assignedDeliveryId={assignedDeliveryID}
          onDeliveryChange={setAssignedDeliveryID}
          sites={sites}
          originSiteId={originSiteId}
          onOriginChange={setOriginSiteId}
          sitesLoading={sitesLoading}
          sitesError={sitesError}
          deliverToSite={deliverToSite}
          canDeliverToSite={canDeliverToSite}
          onDestinationChange={() => setDeliverToSite(!deliverToSite)}
          onConfirm={scheduleOrder}
          onCancel={() => setDisplayScheduleOverlay(false)}
        />
      )
    }else{
      return null
    }
  }

  const updateOrder = async (isDelete) => {
    const request = {
      method: "put",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + user.token,
      },
      body: JSON.stringify({
        orderId: orderToUpdate._id,
        userId: props.farmer._id, 
        status: isDelete ? "delete" : orderToUpdate.status
      })
    };
    let response = await fetch(user.backEndURL + "/order", request);
    let jsonResponse = await response.json();
    if (jsonResponse.success) { 
      alert("Successfully Updated!");
      setOrderToUpdate(null);
      props.updateFarmerList();
    } else {
      alert("Something went wrong...")
    }
    
  }

  const renderUpdateOrder = () => {
    if(orderToUpdate === null){
      return;
    }
    let deliveryDate = new Date(orderToUpdate.delivery_date);
    let selectorData = [
      {name: "Upcoming", value: "upcoming"},
      {name: "Picked Up", value: "pickedUp"},
      {name: "Delivered", value: "delivered"},
      {name: "Cancelled", value: "cancelled"}
    ]

    return(
      <Overlay>
        <div className={styles.scheduleOrderContainer}>
           <h2>Update Order</h2>
          <div className={styles.updateOrderStatus}></div>
          <div className={styles.updateOrderRow}>
           Order ID:{" " + orderToUpdate.order_id}
          </div>
          <div className={styles.updateOrderRow}>
           Delivery ID:{" " + orderToUpdate._delivery.delivery_id}
          </div>
          <div className={styles.updateOrderRow}>
           # of Bags:{" " + orderToUpdate.products[0].amount}
          </div>
          <div className={styles.updateOrderRow}>
            Delivery Date:{" " +deliveryDate.getDate() + "/" + (deliveryDate.getMonth()+1) + "/" + deliveryDate.getFullYear()}
          </div>
          <div className={styles.updateOrderRow}>
            <Selector name="Status" value={orderToUpdate.status} data={selectorData} onChange={(value) => setOrderToUpdate({...orderToUpdate, status: value})}  labelStyle="top" placeholder="Select Status" color="white"/>
          </div>
        <Button name={"Update Order"} onPress={() => updateOrder(false)}/>
        <Button name={"Delete Order"} color={"Error"} onPress={() => updateOrder(true)}/>
        <Button name={"Cancel"} color={"Coal"} onPress={() => setOrderToUpdate(null)}/>
        </div>
      </Overlay>
    ) 
  }

  const renderOrders = () => {
    let filteredOrders = props.farmer._orders;
    if(filteredOrders.length > 0){
      return(
        <>
          {filteredOrders.map(order => {
            let deliveryDate = new Date(order.delivery_date);
            return(
              <tr className={styles.tableRow}>
                <td className={styles.dataBold}>#{order.order_id}</td>
                <td className={styles.dataBold}>#{order._delivery ? order._delivery.delivery_id :" n/a"}</td>
                <td><span className={styles.dataBold}>{renderStatus(order.status)}</span></td>
                <td><span className={styles.dataBold}>{deliveryDate.getDate() + "/" + (deliveryDate.getMonth()+1) + "/" + deliveryDate.getFullYear()} </span></td>
                <td><span className={styles.dataBold}>{(order.products[0]?.amount + (order.products[1]?.amount || 0))} </span>bags</td>
                <td><span className={styles.dataBold}>{order.destination_type === "site" ? "Site" : "Farm"}</span></td>
                <td ><span className={styles.editIcon} onClick={() => {setOrderToUpdate(order)}}>edit</span></td>
              </tr>
            ) 
          })
        }
        </>
      )
    } else {
      return (
        <div className={styles.ordersPlaceholder}>
          No data to display...
        </div>
      )
    }
    
  }
  
  return (
    <div className={styles.container}>
      {renderScheduleOrder()}
      {renderUpdateOrder()}
      <div className={styles.ordersContainer}>
        <div className={styles.ordersListHeader}>Orders</div>
        <table className={styles.orderTable}>
          <tr className={styles.orderHeaderRow}>
            <th>Order ID</th>
            <th>Delivery ID</th>
            <th>Status</th>
            <th>Delivery Date</th>
            <th>Bags</th>
            <th>Destination</th>
          </tr>
          {renderOrders()}
        </table>
      </div>
      <div className={styles.buttonRow}>
        <div className={styles.buttonContainer}>
         <Button name={"Schedule New Order"} color={"Coal"} onPress={() => setDisplayScheduleOverlay(true)}/>
        </div>
      </div>

    </div>
  );
}

const renderStatus = (status) => {
  switch(status){
    case "delivered":
      return <td className={styles.statusDelivered}><span className={styles.statusIcon}>check-circle</span>Delivered</td>
    case "upcoming":
      return <td className={styles.statusUpcoming}><span className={styles.statusIcon}>arrow-circle-right</span>Upcoming</td>
      case "pickedUp":
      return <td className={styles.statusPickedUp}><span className={styles.statusIcon}>arrow-circle-right</span>Picked Up</td>
    case "cancelled":
      return <td className={styles.statusCancelled}><span className={styles.statusIcon}>times-circle</span>Cancelled</td>
    default:
        return <td>N/A</td>
  }

}

export default Orders;
